/** Semver for the playable build. Bump on every shippable milestone. */
export const APP_VERSION = "0.2.54";

/** Working title — LOCKED. */
export const APP_TITLE = "Fill the Hearth";

/** Marketing / tab subtitle. */
export const APP_TAGLINE = "or Perish";

/**
 * Phase gate (integer). Phase 2 = open world walkable voxel playtest.
 * Phase 3 waits on explicit GO.
 */
export const PHASE = 2;

/** Short label shown in HUD / logs. */
export const PHASE_LABEL = "2";

/**
 * Human notes for this build (changelog fragment).
 * Keep terse — also mirrored in package.json description when shipping.
 */
export const VERSION_NOTES = [
  "0.2.54 — Playtest density: streams arteries 6→3 (~50%) + secondary presence harder + origin secondary ban 220 + hub force 280; HUD X/Z=ceil(|pos|/32) signed tiles Y meters; trees edge≥5 + rates ~half; rock −~1/3",
  "0.2.53 — Streams topology+beds: stronger parallel merge (SEP=360 ANGLE=0.52); tighter T-apron + acute X-kill; beds cut 5–16; gradual banks fade ~4–11 (PAD=12); tree scatter edge≥3 (was 7 — 2×2 core never planted); trees 40–90",
  "0.2.52 — Trees+streams hotfix: oak/pine/willow total 40–90 (trunk≤60); stream beds cut 4–14 so channels fill under sea10; parallel artery merge/terminate (SEP=280 ANGLE=0.38); meander + width ±20%; nearestStreamGeom flowDir",
  "0.2.51 — Full-height rescale polish: H=128 sea10 land≤30 surface~15; bedrock y0 indestructible; trees trunk≤60 total≤90; tall-grass −20% clump/short/bare; cold-start loading ring (r5) preload gate before unpause",
].join("\n");
